import React from "react";
import { graphql } from "gatsby";
import { kebabCase } from "../../utilities/helper";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";

/**
 * usually handles embeded video like vimeo or youtube
 */
const VideoModal = ({ video, blockIndex = null }) => {
  const { id, title, videoUrl } = video;
  const anchor = video?.anchor ?? kebabCase(title) ?? id;

  useCollectAnchorLinks(title, video?.anchor, blockIndex);

  return (
    <div className="videoComponent" id={anchor}>
      <iframe
        src={videoUrl}
        title={title}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
      />
    </div>
  );
};

export default VideoModal;

export const query = graphql`
  fragment VideoModal on ContentfulVideo {
    id
    title
    anchor
    videoType
    videoUrl
  }
`;
